import { render, staticRenderFns } from "./CreateUser.vue?vue&type=template&id=85af5ac8&scoped=true"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"
import style0 from "./CreateUser.vue?vue&type=style&index=0&id=85af5ac8&prod&lang=less&scoped=true"
import style1 from "./CreateUser.vue?vue&type=style&index=1&id=85af5ac8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85af5ac8",
  null
  
)

export default component.exports